const EVENT_ID = process.env.EVENT_ID || "";
export const LANDING_PAGE_URL =
  process.env.NEXT_PUBLIC_LANDING_PAGE_URL || "https://moongate.id";

export const getServerSideEventId = async () => {
  return {
    props: {
      eventId: EVENT_ID,
    },
  };
};
